import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	// 默认跳转路由 - 添加到路由数组的首位
	{
		path: '/',
		redirect: '/OneThingQuestionGuide' // 可以修改为任意你想要默认跳转的路径
	},
	//企业迁移登记一件事办事指南
	{
		path: '/migrateWorkGuide',
		name: 'MigrateWorkGuide',
		component: () => import( /* webpackChunkName: "index" */ '../views/migrate/migrateWorkGuide.vue'),
	},
	//企业迁移登记一件事解读
	{
		path: '/migrateInterpret',
		name: 'MigrateInterpret',
		component: () => import( /* webpackChunkName: "index" */ '../views/migrate/migrateInterpret.vue'),
	},
	//企业填报一件事办事指南
	{
		path: '/fillInWorkGuide',
		name: 'FillInWorkGuide',
		component: () => import( /* webpackChunkName: "index" */ '../views/fillIn/fillInWorkGuide.vue'),
	},
	//企业填报一件事解读
	{
		path: '/fillInInterpret',
		name: 'FillInInterpret',
		component: () => import( /* webpackChunkName: "index" */ '../views/fillIn/fillInInterpret.vue'),
	},
	//企业填报立即办理页面
	{
		path: '/onethingServiceFillInOne',
		name: 'OnethingServiceFillInOne',
		component: () => import( /* webpackChunkName: "index" */ '../views/onethingService/fillInOne.vue'),
	},
	//企业破产核查一件事办事指南
	{
		path: '/bankruptcyVerificationWorkGuide',
		name: 'BankruptcyVerificationWorkGuide',
		component: () => import( /* webpackChunkName: "index" */
			'../views/bankruptcyVerification/bankruptcyVerificationWorkGuide.vue'),
	},
	//企业破产核查一件事解读
	{
		path: '/bankruptcyVerificationInterpret',
		name: 'BankruptcyVerificationInterpret',
		component: () => import( /* webpackChunkName: "index" */
			'../views/bankruptcyVerification/bankruptcyVerificationInterpret.vue'),
	},
	//企业信息变更一件事办事指南
	{
		path: '/informationChangeWorkGuide',
		name: 'InformationChangeWorkGuide',
		component: () => import( /* webpackChunkName: "index" */
			'../views/informationChange/informationChangeWorkGuide.vue'),
	},
	//企业信息变更一件事解读
	{
		path: '/informationChangeInterpret',
		name: 'InformationChangeInterpret',
		component: () => import( /* webpackChunkName: "index" */
			'../views/informationChange/informationChangeInterpret.vue'),
	},
	//企业注销一件事办事指南
	{
		path: '/logOffWorkGuide',
		name: 'LogOffWorkGuide',
		component: () => import( /* webpackChunkName: "index" */ '../views/logOff/logOffWorkGuide.vue'),
	},
	//企业注销一件事办事解读
	{
		path: '/logOffInterpret',
		name: 'LogOffInterpret',
		component: () => import( /* webpackChunkName: "index" */ '../views/logOff/logOffInterpret.vue'),
	},
	//办理进度查询progress
	{
		path: '/progress',
		name: 'progress',
		component: () => import( /* webpackChunkName: "index" */ '../views/progress/proGress.vue'),
	},
	//个体工商户转型为企业"一件事"办事指南
	{
		path: '/IndividualToEnterpriseWorkGuide',
		name: 'IndividualToEnterpriseWorkGuide',
		component: () => import( /* webpackChunkName: "index" */
			'../views/IndividualToEnterprise/IndividualToEnterpriseWorkGuide.vue'),
	},
	//个体工商户转型为企业办事解读
	{
		path: '/IndividualToEnterpriseInterpret',
		name: 'IndividualToEnterpriseInterpret',
		component: () => import( /* webpackChunkName: "index" */
			'../views/IndividualToEnterprise/IndividualToEnterpriseInterpret.vue'),
	},
	{
		path: '/bankruptcyGuide',
		name: 'bankruptcyGuide',
		component: () => import( /* webpackChunkName: "index" */
			'../views/bankruptcyGuide/bankruptcyGuide.vue'),
	},
	{
		path: '/OneThingQuestionGuide',
		name: 'OneThingQuestionGuide',
		component: () => import( /* webpackChunkName: "index" */
			'../views/oneThing/onethingGuide.vue'),
	},
	{
		path: '/bankruptcyQuery',
		name: 'bankruptcyQuery',
		component: () => import( /* webpackChunkName: "index" */
			'../views/bankruptcyQuery/bankruptcyQuery.vue'),
	},
	{
		path: '/smartGuide',
		name: 'smartGuide',
		component: () => import( /* webpackChunkName: "index" */
			'../views/smartGuide/smartGuide.vue'),
	},
];

const router = new VueRouter({
	mode: 'hash', // 使用 hash 模式
	routes: routes
});

export default router;